import type { Language } from "./i18n";

/** 5-language text record */
export type L5 = Record<Language, string>;

/** Shorthand to pick text for the active language */
export function tx(map: L5, lang: Language): string {
  return map[lang] || map.en || map.de;
}
